<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="dataTable"
      :model="model"
      :use-action="false"
      :use-default-action="false"
      entity-name="Italy Report"
      icon="mdi-cards"
    >
      <template #right="{}">
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          @click="selectPrinter('ZBon')"
        >
          <v-icon left>
            mdi-export
          </v-icon>
          {{ $t('print') }} Z-Report
        </v-btn>
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          @click="selectPrinter('XBon')"
        >
          <v-icon left>
            mdi-export
          </v-icon>
          {{ $t('print') }} X-Report
        </v-btn>
      </template>
      <template #footer="{}">
        <!-- Display information about the report here if needed -->
      </template>
      <template #[`item.content`]="{item}">
        <v-btn
          class="mr-0"
          color="amber lighten-5 black--text"
          elevation="0"
          small
          @click.stop="reprint(item)"
        >
          <v-icon
            left
          >
            mdi-printer
          </v-icon>
          {{ $t('reprint') }}
        </v-btn>
      </template>
    </ik-data-table>
    <v-dialog
      v-model="showAllfpSNPrinter"
      max-width="600px"
    >
      <base-form
        :schema="this.schemas"
        @close="showAllfpSNPrinter = false"
        @submit="printeNow"
      />
    </v-dialog>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import ItalyZbon, { printItalyXbon, printItalyZbon, reprintFBZBon } from '@/model/dataLayer/api/Italy/ItalyZbon'
import printer from '@/model/dataLayer/api/print/Printer'
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import { VSelect } from 'vuetify/lib/components'
import { showSuccessMessage } from '@/model/utils/utils'

export default {
  name: 'ZBonPage',
  components: {
    BaseForm,
    IkDataTable
  },
  data () {
    return {
      reprintStatus: false,
      reprintFpZNum: '',
      printType: '',
      allPrinter: [],
      showAllfpSNPrinter: false,
      model: ItalyZbon
    }
  },
  computed: {
    schemas () {
      return [
        {
          key: 'fpSN',
          name: 'Printer',
          component: VSelect,
          componentProps: {
            items: this.allPrinter.map(it => {
              it.text = it.fpSN
              it.value = it.fpSN
              return it
            })
          }
        }
      ]
    }
  },
  methods: {
    async printeNow (info) {
      if (!this.reprintStatus) {
        if (this.printType === 'ZBon') {
          await printItalyZbon(info)
        } else {
          await printItalyXbon(info)
        }
      } else {
        await reprintFBZBon(this.reprintFpZNum, info)
        showSuccessMessage('Success')
      }
      this.showAllfpSNPrinter = false
      this.reprintStatus = false
      await this.$refs.dataTable.reload()
    },
    async selectPrinter (type) {
      this.allPrinter = (await printer.getList()).filter(it => it.fpSN)
      this.printType = type
      if (this.allPrinter.length > 1) {
        this.showAllfpSNPrinter = true
      } else {
        await this.printeNow({ fpSN: this.allPrinter[0].fpSN })
      }
    },
    async reprint (item) {
      this.reprintStatus = true
      this.reprintFpZNum = item.fpZNum
      this.allPrinter = (await printer.getList()).filter(it => it.fpSN)
      this.showAllfpSNPrinter = true
    }
  }
}
</script>

<style scoped>

</style>
